var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile",on:{"click":_vm.onClick}},[(_vm.hasAvatar)?_c('img',{staticClass:"profile-photo",attrs:{"src":_vm.avatarPath}}):_c('div',{staticClass:"profile-icon"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }